import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ExceptionsListSkeleton = () => {
  return (
    <>
      <Styles.ExceptionItemsContainer>
        {Array.from({ length: 4 }).map((_, index) => (
          <Styles.TransactionRow key={index} index={index}>
            <Styles.Header>
              <Styles.TitleGroup>
                <Skeleton variant="rounded" width={36} height={20} />
                <Skeleton variant="text" width={140} height={20} />
              </Styles.TitleGroup>
              <Styles.DateAndMenuGroup>
                <Skeleton variant="text" width={160} height={20} />
                <Skeleton variant="circular" width={24} height={24} />
              </Styles.DateAndMenuGroup>
            </Styles.Header>
            <Styles.ChipsRow>
              <Skeleton variant="rounded" width={80} height={24} />
              <Skeleton variant="rounded" width={100} height={24} />
              <Skeleton variant="rounded" width={90} height={24} />
            </Styles.ChipsRow>
          </Styles.TransactionRow>
        ))}
      </Styles.ExceptionItemsContainer>

      <Styles.PaginationContainer>
        <Skeleton variant="rounded" width={240} height={32} />
      </Styles.PaginationContainer>

      <div>
        <Skeleton variant="rounded" width={160} height={32} />
      </div>
    </>
  )
}

export default ExceptionsListSkeleton
